import { Component, OnInit, Output, EventEmitter, Input, TemplateRef, OnDestroy } from '@angular/core';
import { NavigationService } from '../../../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ITableColumnHeader } from '../../../../models/table-column-header';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../../providers/api.service';
import { SM_CONSTANTS } from '../../../../shared/constants/sm-constants';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { MatDialog } from '@angular/material/dialog';
import { BookingDetailsComponent } from 'src/app/shared/components/booking-details/booking-details.component';
import { InvoiceComponent } from 'src/app/shared/components/invoice/invoice.component';
import { MessagingService } from 'src/app/providers/messaging.service';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { AddFutureBookingsComponent } from 'src/app/shared/components/add-future-bookings/add-future-bookings.component';

@Component({
  selector: 'sm-purchase-activity-report',
  templateUrl: './purchase-activity-report.component.html',
  styleUrls: ['./purchase-activity-report.component.scss']
})
export class PurchaseActivityReportComponent implements OnInit, OnDestroy {
  selectedFrequency: any = 2
  // frequencyOfView: any
  selectedView: any = 'Data'
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
 entityHashId: string = ''
  pageTitle: string = 'Booking History' ;
  @Input() pageSubTitle: string = '';
  @Input() showBackButton: boolean = false;
  @Input('buttonText') showButton: string = '';
  @Input()
  headerCustomTemplate!: TemplateRef<any>;
 
  fromDate:any = new Date();
  toDate:any = new Date();
  today: string = new Date().toISOString().slice(0,10)
  purchaseReportData: any[] = [];
  public loader: boolean = false;
  public visible: boolean = false;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant('purchase_report.column_headers.month'),
      columnProperty: "month"
    },
    {
      columnName: this.translateService.instant('purchase_report.column_headers.amount'),
      columnProperty: "total_price"
    },
    {
      columnName: this.translateService.instant('purchase_report.column_headers.purchased'),
      columnProperty: "purchase_count"
    },
    {
      columnName: this.translateService.instant('purchase_report.column_headers.cancelled'),
      columnProperty: "cancel_count"
    },
    
  ];
  
  private _apiSubscription: Subscription;
  constructor(private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private _apiService: ApiService, private loaderservice: LoaderServiceService, public _modelRef: MatDialog, private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,private translateService: TranslateService) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_PURCHASE_REPORT){
        this.purchaseReportData = []
        if(true){
          this.purchaseReportData = resData.result ? resData.result : [] 
          this.purchaseReportData.forEach(item => {
            if(item.date){
              console.log("innnnnn");
              
              item.month = this.convertDateString(item.date)
            }
          });
          //graph assign
          this.graphData = {
            datasets: [{
                label: 'Purchase Activity',
                data: this.purchaseReportData.map(item => {
                  return item.total_price
              }),
                // backgroundColor: "rgb(115 185 243 / 65%)",
                borderColor: "#007ee7",
                fill: false,
                lineTension: 0
            }
            ],
            labels: this.purchaseReportData.map(item => {
              return item.month
          })
      
        }
        }
        this.visible = true
        this.loaderservice.showLoader = false
      }
    })
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
   }

   private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column,index) => {
      let data = [
        "month",
        "amount",
        "purchased",
        "cancelled"
      ]
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(`purchase_report.column_headers.${data[index]}`);
    });
  }
  ngOnInit(): void {
   
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    })
    this.fromDate.setDate(this.fromDate.getDate() - 365);
    this.fromDate = this.fromDate.toISOString().slice(0,10);
    this.toDate = this.toDate.toISOString().slice(0,10);
    this.loaderservice.showLoader = true
    this.visible = false
    this._apiService.getPurchaseReport(this.entityHashId, this.formatDate1(this.fromDate), this.formatDate1(this.toDate))


  }
  search(){
       // Ensure date range is valid based on the selected frequency
       const fromDate = new Date(this.fromDate);
       const toDate = new Date(this.toDate);
   
       if (this.selectedFrequency === 1) { // Daily
         const maxRange = 90;
         const range = (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24);
         if (range > maxRange) {
           const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
             data : {
               title : 'Alert',
               message : 'The selected time frame between from date and to date should be under 90 days.',
               okbtn : 'Ok',
               cancelbtn : 'Cancel',
               type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
             },
             disableClose : true
           });
           return;
         }
       } else if (this.selectedFrequency === 2) { // Monthly
         const maxRange = 36;
         const range = (toDate.getMonth() - fromDate.getMonth() + (12 * (toDate.getFullYear() - fromDate.getFullYear())));
         if (range > maxRange) {
           const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
             data : {
               title : 'Alert',
               message : 'The selected time frame between from date and to date should be under 3 years.',
               okbtn : 'Ok',
               cancelbtn : 'Cancel',
               type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
             },
             disableClose : true
           });
           return;
         }
       }
   
       //end
    if(this.selectedFrequency == 2){
      this.tableDisplayColumns = [
        {
          columnName: 'month',
          columnProperty: "month"
        },
        {
          columnName: 'amount',
          columnProperty: "total_price"
        },
        {
          columnName: 'purchased',
          columnProperty: "purchase_count"
        },
        {
          columnName: 'cancelled',
          columnProperty: "cancel_count"
        },
      ]
      this.loaderservice.showLoader = true
      this.visible = false
      this._apiService.getPurchaseReport(this.entityHashId,  this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
    }
    else{
      this.tableDisplayColumns = [
        {
          columnName: 'month',
          columnProperty: "month"
        },
        {
          columnName: 'amount',
          columnProperty: "total_price"
        },
        {
          columnName: 'purchased',
          columnProperty: "purchase_count"
        },
        {
          columnName: 'cancelled',
          columnProperty: "cancel_count"
        },
      ]
      this.loaderservice.showLoader = true
      this.visible = false
      this._apiService.getPurchaseReport(this.entityHashId,  this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
    }
  }

  // changeFrequency(){
  //   if(this.selectedFrequency == 2){
  //     this.tableDisplayColumns = [
  //       {
  //         columnName: 'month',
  //         columnProperty: "month"
  //       },
  //       {
  //         columnName: 'total sales',
  //         columnProperty: "totalSales"
  //       },
  //       {
  //         columnName: 'home sales',
  //         columnProperty: "homeSales"
  //       },
  //       {
  //         columnName: 'shop sales',
  //         columnProperty: "shopSales"
  //       },
  //     ]
  //     this.loaderservice.showLoader = true
  //     this.visible = false
  //     this._apiService.getPurchaseReport(this.entityHashId,  this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
  //   }
  //   else{
  //     this.tableDisplayColumns = [
  //       {
  //         columnName: 'month',
  //         columnProperty: "date"
  //       },
  //       {
  //         columnName: 'total sales',
  //         columnProperty: "totalSales"
  //       },
  //       {
  //         columnName: 'home sales',
  //         columnProperty: "homeSales"
  //       },
  //       {
  //         columnName: 'shop sales',
  //         columnProperty: "shopSales"
  //       },
  //     ]
  //     this.loaderservice.showLoader = true
  //     this.visible = false
  //     this._apiService.getPurchaseReport(this.entityHashId,  this.formatDate1(this.fromDate), this.formatDate1(this.toDate))
  //   }
  // }
 
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  navigate(){
    this.router.navigate(['../'], {relativeTo: this.route ,  queryParamsHandling: 'preserve'})
  }
 
  toShowGraph: boolean = false
  graphData: any
  changeView(){
    if(this.selectedView == 'Data'){
      this.toShowGraph = false
    }else if(this.selectedView == 'Graph'){
      
        this.graphData = {
          datasets: [{
              label: 'Purchase Activity',
              data: this.purchaseReportData.map(item => {
                return item.total_price
            }),
              // backgroundColor: "rgb(115 185 243 / 65%)",
              borderColor: "#007ee7",
              fill: false,
              lineTension: 0
          }
          ],
          labels: this.purchaseReportData.map(item => {
            return item.month
        })
    
      }
      
    this.toShowGraph = true
    }
    
  }
  
  convertDateString(dateString:any) {
    // Split the input string to extract the year and month
    const [year, month] = dateString.split('-');

    // Array of month names
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Convert month from string to number and adjust for zero-based index
    const monthIndex = parseInt(month, 10) - 1;

    // Retrieve the month name
    const monthName = monthNames[monthIndex];

    // Return the formatted string
    return `${monthName} ${year}`;
}
formatDate1(dateStr:Date) {

  let curdate = new Date(dateStr).toLocaleString('en-CA', {
    timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' 
}).slice(0, 10);
    console.log(curdate);
    
    return curdate
}

}

